import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";

const schema = Yup.object({
  st_site_company_name: Yup.string().required("Required"),
  st_site_company_sname: Yup.string().required("Required"),
  st_site_company_logo: Yup.object()
    .required("Required")
    .test(
      "fileType",
      "Only Images are Allowed",
      (value: any) =>
        value && ["image/jpeg", "image/png", "image/gif"].includes(value.type)
    )
    .test(
      "fileSize",
      "File size must be less than 100 KB",
      (value: any) => value && value.size <= 100 * 1024
    ),
  st_site_company_email: Yup.string().required("Required"),
  st_site_company_phone: Yup.string().required("Required"),
  st_site_company_address: Yup.string().required("Required"),
});

interface props {
  saveSettings: (dt: any) => void;
  dataIn: any;
}

const SiteSettings: React.FC<props> = ({ saveSettings, dataIn }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema),
  });
  const onSubmit = (data: any) => {
    saveSettings(data);
  };

  const hintTitleDisplay = (title: string, hint: string) => {
    return (
      <span>
        {title} <br />
        <small>{hint}</small>
      </span>
    );
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 12,
      name: "st_site_company_name",
      element: {
        placeHolder: "Enter Company Name",

        label: hintTitleDisplay(
          "Company Name",
          "Enter the full legal name of the company."
        ),
        max: 255,
        classList: ["sds-hz-label-30"],
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "TEXT_BOX",
      width: 12,
      name: "st_site_company_sname",
      element: {
        label: hintTitleDisplay(
          "Company Short Name",
          "Provide a short or abbreviated name for the company."
        ),
        classList: ["sds-hz-label-30"],
        placeHolder: "Enter Company Short Name",
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "FILE",
      width: 12,
      name: "st_site_company_logo",
      element: {
        label: hintTitleDisplay(
          "Company Logo",
          "Upload the company's logo in a supported image format (e.g., PNG, JPEG)."
        ),
        placeHolder: "(Image Only)",
        classList: ["sds-hz-label-30"],
        accept: "*",
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "FILE",
      width: 12,
      name: "st_site_login_logo",
      element: {
        label: hintTitleDisplay(
          "Company Login Logo",
          "Upload the company's Login logo in a supported image format (e.g., PNG, JPEG)."
        ),
        placeHolder: "(Image Only)",
        classList: ["sds-hz-label-30"],
        accept: "*",
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "FILE",
      width: 12,
      name: "st_site_company_footer_logo",
      element: {
        label: hintTitleDisplay(
          "Company Footer Logo",
          "Upload the company's footer logo in a supported image format (e.g., PNG, JPEG)."
        ),
        placeHolder: "(Image Only)",
        classList: ["sds-hz-label-30"],
        accept: "*",
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "TEXT_BOX",
      width: 12,
      name: "st_site_company_email",
      element: {
        label: hintTitleDisplay(
          "Company Email ID",
          "Enter the official email address for the company."
        ),
        placeHolder: "Enter Email ID",
        classList: ["sds-hz-label-30"],
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "TEXT_BOX",
      width: 12,
      name: "st_site_company_phone",
      element: {
        label: hintTitleDisplay(
          "Company Phone No.",
          "Provide the primary contact number for the company."
        ),
        placeHolder: "Enter  Phone No.",
        classList: ["sds-hz-label-30"],
        isHorizontal: true,
        size: "small",
      },
    },
    {
      type: "TEXTAREA",
      width: 12,
      name: "st_site_company_address",
      element: {
        label: hintTitleDisplay(
          "Company Address",
          "Enter the complete address of the company, including city and state."
        ),
        placeHolder: "Enter Address",
        classList: ["sds-hz-label-30"],
        isHorizontal: true,
        size: "small",
        // rows: 2
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submit",
      class_name: "has-text-right",
      element: {
        label: "Save Settings",
        onClick: handleSubmit(onSubmit),
        classList: ["smart-action-button"],
      },
    },
  ];
  return (
    <>
      <div className="mt-3 sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default SiteSettings;
